/**
 * @generated SignedSource<<b6375be0e42c5b4f002abd1f9db6bfb9>>
 * @relayHash 56b87b74f64113861705dd1988f8db49
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 585a0e9858aab3e331636683e2d600bdac07bb406e422911f09719820a445210

import type { ConcreteRequest, Query } from 'relay-runtime';
export type linkPickerResolversPagesQuery$variables = {
  cloudId: string;
  helpCenterAri: string;
};
export type linkPickerResolversPagesQuery$data = {
  readonly helpCenter: {
    readonly helpCenterPages: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id?: string;
          readonly name?: {
            readonly default: string;
          } | null | undefined;
          readonly updatedAt?: string | null | undefined;
        } | null | undefined;
      }> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type linkPickerResolversPagesQuery = {
  response: linkPickerResolversPagesQuery$data;
  variables: linkPickerResolversPagesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/),
    {
      "concreteType": "HelpCenterPageName",
      "kind": "LinkedField",
      "name": "name",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "default"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "updatedAt"
    }
  ],
  "type": "HelpCenterPage"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "linkPickerResolversPagesQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "HelpCenterPageQueryResultConnection",
            "kind": "LinkedField",
            "name": "helpCenterPages",
            "plural": false,
            "selections": [
              {
                "concreteType": "HelpCenterPageQueryResultEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "linkPickerResolversPagesQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "HelpCenterPageQueryResultConnection",
            "kind": "LinkedField",
            "name": "helpCenterPages",
            "plural": false,
            "selections": [
              {
                "concreteType": "HelpCenterPageQueryResultEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "585a0e9858aab3e331636683e2d600bdac07bb406e422911f09719820a445210",
    "metadata": {},
    "name": "linkPickerResolversPagesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ef4e103f1ff25f450542f68c9fca0330";

export default node;
